import styled, { css } from "styled-components";

const CSSAppearanceDefault = css`
    background: transparent;
    border-color: #1122;
    color: #334;

    &:disabled {
        opacity: .7;
    }

    &:enabled {
        &:hover {
            background: #0001;
            border-color: transparent;
        }

        &:active {
            background: #0002;
            border-color: transparent;
        }
    }
`;

const CSSAppearancePrimary = css`
    background: var(--color, royalblue);
    border-color: transparent;
    color: #fff;

    &:disabled {
        opacity: .7;
    }

    &:enabled {
        &:hover {
            background: #35d;
        }

        &:active {
            background: #14d;
        }
    }
`;

const CSSAppearanceSubtle = css`
    background: transparent;
    border-color: transparent;
    color: #334;

    &:disabled {
        opacity: .7;
    }

    &:enabled {
        &:hover {
            background: #0001;
        }

        &:active {
            background: #0002;
        }
    }
`;

const CSSAppearanceDanger = css`
    background: #de350b;
    border-color: transparent;
    color: #fff;

    &:disabled {
        opacity: .7;
    }

    &:enabled {
        &:hover {
            background: #bf2600;
        }

        &:active {
            background: #9e250c;
        }
    }
`;

const APPEARANCE = {
    danger: CSSAppearanceDanger,
    default: CSSAppearanceDefault,
    primary: CSSAppearancePrimary,
    subtle: CSSAppearanceSubtle,
};

const CSSSizeDefault = css`
    padding: 6px 12px;
`;

const CSSSizeIcon = css`
    padding: 6px 8px;
`;

const CSSSizeLarge = css`
    padding: 12px 24px;
`;

const CSSSizeSmall = css`
    padding: 2px 6px;
`;

const SIZE = {
    default: CSSSizeDefault,
    icon: CSSSizeIcon,
    large: CSSSizeLarge,
    small: CSSSizeSmall,
};

interface IButtonProps {
    $appearance?: "danger" | "default" | "primary" | "subtle"
    $size?: "default" | "icon" | "large" | "small"
}

export default styled.button.attrs(
    (props) => (
        {
            type: props.type ?? "button",
        }
    )
)<IButtonProps>`
    border: 1px solid;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    font-weight: 500;
    outline-color: transparent;
    text-decoration: none;
    transition: 200ms;
    white-space: nowrap;
    width: min-content;

    &:enabled {
        cursor: pointer;
    }

    &:focus-visible {
        outline: 2px solid royalblue;
        outline-offset: 2px;
    }

    ${ ({ $appearance }) => APPEARANCE[$appearance] ?? APPEARANCE.default };
    ${ ({ $size }) => SIZE[$size] ?? SIZE.default };
`;
